import React, { useReducer } from 'react';
import { Link, Route, Switch } from 'react-router-dom';

import { accountService } from '../_services';
import { useTranslation } from 'react-i18next';

import { List } from './reservations/List';
import { AddEdit } from './reservations/AddEdit';

function Details({ match }) {
  const { t } = useTranslation();
  const { path } = match;
  const user = accountService.userValue;
  return (
    <div>
      <div className="form-group">
        <h2 className="card-header">{t('My Account')}</h2>
        <p className="rent-agree-marg">
          <strong>{t('Name')}</strong> <br /> {user.title} {user.firstName} {user.lastName}<br /><br />
          <strong>Email</strong> <br /> {user.email}

        </p>

      </div>
      {user.loginTypeID == 1 &&
      <div className="form-group update -btn-pad">
              <Link className="home-btn update-btn" to={`${path}/update`}>{t('Update Account')}</Link>
      </div>}

      <div className="cust-ft-top">
        <h3 className="card-header cust-footer">
          <Link to="/home" className="btn btn-link">{t('Home')}</Link>
        </h3>
      </div>
    </div>
  );
}

export { Details };